import React, { Component } from "react";
import { store } from '../../redux/store'

let timeArr = [];
let visitorNo = Date.parse(new Date()) + Math.floor(Math.random() * 10);
class ChatPlatformWilldesk extends Component {
    state = {
        name: '',
        user_id:'',
        shop_owner:'',
        shop_name:'',
        review:'',
        created_at:'',
        level:'',
        email:'',
        shopify_level:'',
        from_app: this.props.App,
    };

    // 设置全局用户信息
    setSettingInfo = (data) => {
        let res = data.shop_data;
        let review = data.head_data.review;
        if(res) {
            window.email = res.email;
            window.shopOwner = res.shop_owner;
            this.setState({
                name:res.shop_owner !== null && res.shop_owner !== '' ? res.shop_owner : res.shop_owner,
                email:res.email !== null && res.email !== '' ? res.email : 'none',
                user_id:res.id !== null && res.id !== '' ? res.id : 'seoant_visitor_' + visitorNo,
                shop_owner:res.name !== null && res.name !== '' ? res.name : 'none',
                shop_name:res.shop_name !== null && res.shop_name !== '' ? res.shop_name : 'none',
                review: review !== null && review !== '' ? review : 'none',
                created_at:res.created_at !== null && res.created_at !== '' ? res.created_at : 'none',
                level:res.level !== null && res.level !== '' ? (res.level !== 1 ? 'Pricing' : 'Free') : 'none',
                shopify_level:res.plan_display_name !==null && res.plan_display_name !== ''? res.plan_display_name : 'none'
            },()=>{ 
                this.startIntercom()
            })
        } else {
            this.setState({
                user_id : 'seoant_visitor_' + visitorNo,
                name    : 'seoant_visitor'
            },()=>{
                this.startIntercom()
            })
        }
    }

     // 平台启动
     startIntercom = async () => {
        Boolean(window.Willdesk) && window.Willdesk.boot({
            'user_email':this.state.email,
            'user_name': this.state.name,
            'user_id': 'SEOAnt_'+this.state.user_id,
            'shopUrl' : this.state.shop_owner,
            'appUserId': this.state.user_id,
            'fromApp': this.state.from_app,
            'shopifyPlan': this.state.shopify_level,
            'review': this.state.review,
            'plan': this.state.level,
            'first_name':this.state.name,
        })
    }

    // 获取缓存
    getStoreChatShopInfo = () => {
        // 判断全局状态是否有值
        const stores = store.getState();
        if(Boolean(stores.public.publicInit.shop_data) && Object.keys(stores.public.publicInit.shop_data)?.length > 0) {
            this.setSettingInfo(stores.public.publicInit);
            this.delTimeArrData();
        } else {
            if(timeArr.length === 0) {
                let timer = setInterval(() => {
                    this.getStoreChatShopInfo();
                }, 3000)
                timeArr.push(timer);
            }
        }
    }

    // 删除订阅器
    delTimeArrData = () => {
        timeArr.map( timer =>{
            clearInterval(timer);
            timeArr.pop();
            return false;
        })
    }

    componentDidMount() {
        // 获取缓存数据
        this.getStoreChatShopInfo();
    }

    componentWillUnmount() {
        this.delTimeArrData();
    }

    render() {
        return <></>;
    }
}

export default ChatPlatformWilldesk;